import { TextTooltip } from '~/@mid_ui/text-tooltip/TextTooltip'
import { ProjectYieldTooltip } from './ProjectYieldTooltip'

export const projectTooltipByType = {
  category: <TextTooltip text="Typ nehnuteľnosti, ktorou je úver zaistený" />,
  yield: <ProjectYieldTooltip />,
  amountMax: (
    <TextTooltip text="V aktuálnej tranži je dostupná určitá suma na investovanie. Po dosiahnutí plánovaného objemu investície sa táto investičná príležitosť uzavrie." />
  ),
  ltl: (
    <TextTooltip text="Pomer medzi poskytnutým úverom a tržnou hodnotou zaistenej nehnuteľnosti. Čím je hodnota LTL nižšia, tým je investícia výhodnejšia" />
  ),
  loanPurpose: (
    <TextTooltip text="Účel, na aký je úver a financovanie poskytnuté" />
  ),
  investedAmount: <TextTooltip text="Celková zainvestovaná čiastka" />,
  payoutDate: (
    <TextTooltip text="Dátum splatenia investovanej čiastky investorom" />
  ),
  paymentType: (
    <TextTooltip text="Typ výnosu ovplyvňuje frekvenciu vyplácania výnosu a výšku úroku." />
  ),
  revenuesFlowStartDate: (
    <TextTooltip text="Dátum, od kedy sa vaša investícia začína úročiť" />
  ),
  totalAmountToBePaid: (
    <TextTooltip text="Celková čiastka, ktorá bude vyplatená investorom" />
  ),
  investmentPeriod: (
    <TextTooltip text="Toto obdobie definuje čas, počas ktorého bude investícia pre investora úročená. Po uplynutí tohto obdobia bude investícia aj s výnosmi vrátená investorovi. Toto obdobie môže byť predĺžené o maximálne 12 mesiacov." />
  ),
  totalAmountPaid: (
    <TextTooltip text="Celková čiastka, ktorá bola vyplatená investorom" />
  ),
  riskScore: (
    <TextTooltip text="Posudzujeme bezpečnosť konkrétneho zverejneného úveru na škále od A+ (vysoká bezpečnosť) po E (nízka bezpečnosť). A+ až A- Super príležitosť, B+ až B- Dobrá voľba, C+ až C- Rozumná možnosť, D+ až D- Nie pravidelne, E Riziko prehry" />
  ),
  companyRegister: (
    <TextTooltip text="Na platforme je možné investovať aj ako firma, či podnikateľ s IČO. Ak je to Váš prípad, vyberte túto možnosť." />
  ),
  companyRegisterRequirement: (
    <TextTooltip text="Investovanie ako firma je aktuálne dostupné len pre živnostníkov a spoločnosti s jediným konateľom. Ak nesplňujete túto podmienku, pokračujte prosím s bežným (osobným) profilom." />
  ),
  yieldCompoundingRevenue: (
    <TextTooltip text="Tento stĺpec je relevantný iba pre investície s rastúcim výnosom" />
  ),
}
